<div class="spm-panel">

    <!-- ── Header ──────────────────────────────────────────── -->
    <div class="spm-header">
      <div class="spm-header__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M16 3h5v5"/>
          <path d="M8 3H3v5"/>
          <path d="M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"/>
          <path d="m15 9 6-6"/>
        </svg>
      </div>
      <div class="spm-header__body">
        <h2 class="spm-header__title">{{ 'segregation_modal.title' | translate }}</h2>
        <p class="spm-header__sub"
           [innerHTML]="'segregation_modal.subtitle' | translate:{ orderName: data.orderName, count: groups.length }">
        </p>
      </div>
      <button class="spm-header__close" (click)="cancel()" [attr.aria-label]="'segregation_modal.cancel' | translate">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>
      </button>
    </div>

    <!-- ── Rule banner ─────────────────────────────────────── -->
    <div class="spm-rule-banner">
      <svg class="spm-rule-banner__icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
        <path d="M7 6.5v3M7 4.25v.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <span class="spm-rule-banner__text">{{ 'segregation_modal.splitting_rule_label' | translate }}</span>
      <strong class="spm-rule-banner__name">{{ mechanism.name }}</strong>
      <span class="spm-rule-banner__sep">·</span>
      <span class="seg-chip" [ngClass]="'seg-chip--' + mechanism.condition_type">
        {{ conditionLabel(mechanism.condition_type) }}
      </span>
    </div>

    <!-- ── Groups ──────────────────────────────────────────── -->
    <div class="spm-groups">

      <!-- Groups: index 0 = current order (retained), index 1+ = new child orders -->
      <div *ngFor="let group of groups; let i = index; trackBy: trackByGroupKey"
           class="spm-group"
           [ngClass]="i === 0 ? 'spm-group--current' : 'spm-group--' + group.condition_type">

        <!-- Group header -->
        <div class="spm-group__head">
          <!-- Index 0: current / original order -->
          <ng-container *ngIf="i === 0">
            <span class="spm-group__badge spm-group__badge--current">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M5 1v4M3 3l2-2 2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1 8h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              {{ 'segregation_modal.current_order_label' | translate }}
            </span>
            <span class="spm-group__label">{{ data.orderName }}</span>
          </ng-container>
          <!-- Index 1+: new child orders -->
          <ng-container *ngIf="i > 0">
            <span class="spm-group__badge">{{ i }}</span>
            <span class="spm-group__label">{{ group.split_label || '—' }}</span>
          </ng-container>
          <span class="spm-group__count">
            {{ group.line_count }}
            {{ (group.line_count === 1 ? 'segregation_modal.line_singular' : 'segregation_modal.line_plural') | translate }}
          </span>
        </div>

        <!-- Lines table -->
        <div class="spm-lines">
          <div class="spm-lines__row spm-lines__row--header">
            <span class="spm-lines__cell spm-lines__cell--product">{{ 'segregation_modal.col_product' | translate }}</span>
            <span class="spm-lines__cell spm-lines__cell--sku">{{ 'segregation_modal.col_sku' | translate }}</span>
            <span class="spm-lines__cell spm-lines__cell--qty">{{ 'segregation_modal.col_qty' | translate }}</span>
            <span class="spm-lines__cell spm-lines__cell--price">{{ 'segregation_modal.col_unit_price' | translate }}</span>
            <span class="spm-lines__cell spm-lines__cell--total">{{ 'segregation_modal.col_total' | translate }}</span>
          </div>
          <div class="spm-lines__row"
               *ngFor="let line of visibleLines(group, i)">
            <span class="spm-lines__cell spm-lines__cell--product">{{ line.product_name }}</span>
            <span class="spm-lines__cell spm-lines__cell--sku">{{ line | productCode:'—' }}</span>
            <span class="spm-lines__cell spm-lines__cell--qty">{{ line.qty | number:'1.0-2' }}</span>
            <span class="spm-lines__cell spm-lines__cell--price">{{ line.price_unit | number:'1.2-2' }}</span>
            <span class="spm-lines__cell spm-lines__cell--total">{{ line.total | number:'1.2-2' }}</span>
          </div>
          <!-- Show more / less -->
          <button class="spm-lines__expand"
                  *ngIf="group.lines.length > LINES_INITIAL"
                  (click)="toggleExpand(i)">
            <ng-container *ngIf="!expandedGroups.has(i)">
              {{ 'segregation_modal.show_more' | translate:{ count: hiddenCount(group, i) } }}
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </ng-container>
            <ng-container *ngIf="expandedGroups.has(i)">
              {{ 'segregation_modal.show_less' | translate }}
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 8l4-4 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </ng-container>
          </button>
        </div>

      </div>
    </div>

    <!-- ── Footer ──────────────────────────────────────────── -->
    <div class="spm-footer">
      <button class="spm-btn spm-btn--ghost" (click)="cancel()">{{ 'segregation_modal.cancel' | translate }}</button>
      <div class="spm-footer__actions">
        <button class="spm-btn spm-btn--secondary" (click)="skipSplit()">
          {{ 'segregation_modal.assign_company_only' | translate }}
        </button>
        <button class="spm-btn spm-btn--primary" (click)="confirm()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 3h5v5"/>
            <path d="M8 3H3v5"/>
            <path d="M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"/>
            <path d="m15 9 6-6"/>
          </svg>
          {{ 'segregation_modal.confirm_split' | translate }}
        </button>
      </div>
    </div>

</div>
